module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content animated fadeInRight tabBox",
    attrs: {
      "id": "ac-to-rb"
    }
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('account-list', {
    on: {
      "onerror": _vm.openModal
    }
  })], 1), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.closeModal
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-795aba03","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/accountcheck/PageAccountCheckToRb.vue
// module id = 1579
// module chunks = 0